import {useMapEvents} from "react-leaflet";
import {useEffect} from "react";

export const AdminMap = ({position, clickHandler}) => {
    const map = useMapEvents({
        click: e => {
            clickHandler(e.latlng)
        }
    })

    const lat = position && position[0];
    const lng = position && position[1];

    useEffect(() => {
        if (lat != null && lng != null) {
            map.flyTo([lat, lng], 12);
        }
    }, [map, lat, lng]);

    return null;
}